import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

export const createCampaignMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/campaign-mappings/' as const,
  method: 'POST',
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
  querySchema: z.object({
    settingsId: z.string(),
    taxonomyItemId: z.string(),
    platformId: z.string(),
    platformName: z.string(),
    mediaRowId: z.string(),
  }),
  requestSchema: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  snakeCaseQueryParams: true,
});

export const deleteCampaignMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/campaign-mappings/delete/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
  querySchema: z.object({
    settingsId: z.string(),
    taxonomyItemId: z.string(),
    campaignMappingIds: z.array(z.string()),
  }),
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});
